export const supplementaryCardInstallments = {
    enabled: true,
    _description: 'Enables the supplementary card installments feature',
};
